// extracted by mini-css-extract-plugin
export default {"scrollContainer":"TableProductsWrapper_scrollContainer__ddNTl","gridContainer":"TableProductsWrapper_gridContainer__geAJT"};